const defaultChartConfig = {
  data: {},
  options: {
    // animation: {
    //   duration: 0, // Disable animation to test the jitter behavior
    // },
    // hover: {
    //   animationDuration: 0, // Disable hover animation to prevent jitter
    // },
    scales: {
      x: {
        beginAtZero: true,
        title: {
          display: true,
        },
        offset: true,
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
        },
        ticks: {
          callback: function (value, index, values) {
            // Customize the format here
            return value >= 1000000 ? value / 1000000 + "M" : value;
          },
        },
      },
    },
    interaction: {
      mode: "index",
      axis: "x",
      intersect: true,
    },
    plugins: {
      tooltip: {
        mode: "nearest",
        intersect: false,
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            label += context.raw.toLocaleString();
            return label;
          },
        },
      },
    },
    hover: {
      mode: "index",
      intersect: true,
    },
    responsive: true,
  },
};

const defaultTableWellsConfig = {
  paging: false,
  ordering: true,
  info: false,
  searching: false,
  responsive: true,
  columns: [
    {
      className: "text-left",
      data: "name",
    },
    {
      className: "text-right",
      data: "count",
    },
  ],
  columnDefs: [
    {
      orderable: true,
      targets: [0, 1],
    },
    // {
    //   width: "65%",
    //   targets: 0,
    // },
    {
      targets: 1,
      render: $.fn.dataTable.render.number(",", ".", 0, ""),
    },
  ],
};

const defaultTableDepthsConfig = {
  paging: false,
  ordering: false,
  info: false,
  searching: false,
  responsive: true,
  columns: [
    {
      className: "text-left dt-head-hide",
      data: "stat",
    },
    {
      className: "text-right dt-head-hide",
      data: "value",
    },
  ],
  columnDefs: [
    {
      targets: 1,
      render: $.fn.dataTable.render.number(",", ".", 0, "", " ft."),
    },
  ],
};

const defaultTableConfig = {
  paging: false,
  ordering: true,
  info: false,
  searching: false,
  // responsive: true,
  scrollX: true,
  columns: [
    { className: "text-left", title: "API", data: "api" },
    { className: "text-left", title: "Operator", data: "operator" },
    {
      className: "text-right",
      title: "Trailing 12 Months BOE",
      data: "trailling_12_months",
    },
    { className: "text-right", title: "Total BOE", data: "total_boe" },
    { className: "text-right", title: "Total Gas (MCF)", data: "total_gas" },
    { className: "text-right", title: "Total Oil (BBL)", data: "total_oil" },
  ],
  columnDefs: [
    {
      targets: [2, 3, 4, 5],
      render: $.fn.dataTable.render.number(",", ".", 2, ""),
    },
  ],
};

function capitalizeWord(word) {
  const capitalized = word.charAt(0).toUpperCase() + word.slice(1);

  return capitalized;
}

function processDepthsData(data) {
  const result = {};

  Object.entries(data).forEach(([keyData, valueData]) => {
    const rows = Object.entries(valueData).map(([key, value]) => {
      return { stat: capitalizeWord(key), value: value };
    });
    result[keyData] = rows;
  });

  return result;
}

class UpstreamData extends HTMLElement {
  constructor() {
    super();
    this.id = this.getAttribute("data-id");
    this.state = this.getAttribute("data-state");
    this.basin = this.getAttribute("data-basin");
    this.apiUrl = "https://api.rextag.com/wells-statistics";
    this.upstreamData = {};

    console.log("UpstreamData", this.id, this.state, this.basin);

    this.getUpstreamData();
  }

  async getUpstreamData() {
    if (this.state == "" && this.basin == "") return;

    const apiParams =
      this.state != "" ? "?state=" + this.state : "?basin=" + this.basin;

    const fetchUrl = this.apiUrl + apiParams;

    try {
      const response = await fetch(fetchUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const json = await response.json();
      console.log(json);
      this.processData(json);
    } catch (error) {
      console.error(error.message);
    }
  }

  processData(data) {
    this.upstreamData.cha_monthly = data.wells.histogram;
    this.upstreamData.cha_prod_operator = data.wells.grouped.operator;
    this.upstreamData.cha_prod_formation = data.wells.grouped.formation;
    this.upstreamData.cha_prod_county = data.wells.grouped.county;
    this.upstreamData.tbl_top_10 = data.wells.top;
    this.upstreamData.tbl_set_depths = processDepthsData(
      data.completions.statistics
    );
    this.upstreamData.tbl_set_wells = data.completions.grouped;
    this.upstreamData.cha_comp_wells = data.completions.histogram;
    this.upstreamData.cha_comp_permits = data.permits.histogram;
    this.upstreamData.cha_comp_operators =
      data.completions.last_12months.operator;
    this.upstreamData.cha_comp_county = data.completions.last_12months.county;

    console.log(this.upstreamData);

    this.renderCharts();

    this.renderTables();
  }

  renderCharts() {
    const chartDataMonthly = this.processChartDataMonthly("cha_monthly");
    this.generateChart("cha_monthly", chartDataMonthly, "Date", "BBL/Month");

    const chartDataProdOperator =
      this.processChartDataProd("cha_prod_operator");
    this.generateChart("cha_prod_operator", chartDataProdOperator, "", "BBL");

    const chartDataProdFormation =
      this.processChartDataProd("cha_prod_formation");
    this.generateChart("cha_prod_formation", chartDataProdFormation, "", "BBL");

    const chartDataProdCounty = this.processChartDataProd("cha_prod_county");
    this.generateChart("cha_prod_county", chartDataProdCounty, "", "BBL");

    const chartDataCompWells = this.processChartDataComp("cha_comp_wells");
    this.generateChart("cha_comp_wells", chartDataCompWells, "", "Wells");

    const chartDataCompPermits = this.processChartDataComp("cha_comp_permits");
    this.generateChart("cha_comp_permits", chartDataCompPermits, "", "Wells");

    const chartDataOperators = this.processChartDataComp("cha_comp_operators");
    this.generateChart("cha_comp_operators", chartDataOperators, "", "Wells");

    const chartDataCompCounty = this.processChartDataComp("cha_comp_county");
    this.generateChart("cha_comp_county", chartDataCompCounty, "", "Wells");
  }

  renderTables() {
    // const tableDataTop10 = this.processTableData("tbl_top_10");
    const tableDataTop10 = this.upstreamData.tbl_top_10;
    const tableConfigTop10 = { ...defaultTableConfig };
    this.generateTable("tbl_top_10", tableDataTop10, tableConfigTop10);

    Object.entries(this.upstreamData.tbl_set_wells).map(([key, value]) => {
      // const wellsData = this.processTableSetData("tbl_set_wells", key);
      const wellsData = this.upstreamData.tbl_set_wells[key];
      const wellsConfig = { ...defaultTableWellsConfig };
      wellsConfig.columns[0].title = capitalizeWord(key);
      wellsConfig.columns[1].title = "Well Count";
      wellsConfig.order = [[1, "desc"]];
      this.generateTable(key, wellsData, wellsConfig);
    });

    Object.entries(this.upstreamData.tbl_set_depths).map(([key, value]) => {
      const depthsData = this.upstreamData.tbl_set_depths[key];
      const depthsConfig = { ...defaultTableDepthsConfig };
      this.generateTable(key, depthsData, depthsConfig);
    });
  }

  generateTable(tableId, tableData, tableConfig) {
    console.log("generateTable", tableId, tableData, tableConfig);
    if (!tableId) return;

    const tableElement = this.querySelector(
      'table[data-table-id="' + tableId + '"]'
    );
    tableConfig.data = tableData;
    const datatable = new DataTable(tableElement, tableConfig);
  }

  generateChart(chartId, chartData, xTitle, yTitle) {
    // console.log("generateChart", chartId, chartData, xTitle, yTitle);
    if (!chartId) return;
    // console.log("data for chart", this.upstreamData[chartId]);

    const container = this.querySelector('div[data-id="' + chartId + '"]');

    if (!container) return;

    const chartType = container.getAttribute("data-chart-type");
    const context = container.querySelector("canvas").getContext("2d");
    const chartConfig = { ...defaultChartConfig };

    // console.log("default config", defaultChartConfig);

    chartConfig.type = chartType;

    // console.log('scale titles', xTitle, yTitle);
    chartConfig.options.scales.x.title.text = xTitle;
    chartConfig.options.scales.y.title.text = yTitle;

    // const isSingleDataset = chartData.datasets.length == 1;
    // chartConfig.options.scales.y.stacked = !isSingleDataset; // Stack if it's not a single dataset chart

    chartConfig.data = { ...chartData };
    // console.log('chart config', chartConfig);

    return new Chart(context, { ...chartConfig });
  }

  processChartDataMonthly(chartId) {
    const result = { labels: [], datasets: [] };

    const data = this.upstreamData[chartId];

    const container = this.querySelector('div[data-id="' + chartId + '"]');
    if (!container) return;

    const ctx = container.querySelector("canvas").getContext("2d");

    // Oil Gradient
    const oilGradient = ctx.createLinearGradient(0, 0, 0, 400);
    oilGradient.addColorStop(0, "rgba(26, 182, 95, 0.8)"); // #1ab65f with 0.8 opacity
    oilGradient.addColorStop(1, "rgba(26, 182, 95, 0.1)"); // #1ab65f with 0.1 opacity

    // Gas Gradient
    const gasGradient = ctx.createLinearGradient(0, 0, 0, 400);
    gasGradient.addColorStop(0, "rgba(226, 32, 38, 0.8)"); // #e22026 with 0.8 opacity
    gasGradient.addColorStop(1, "rgba(226, 32, 38, 0.1)"); // #e22026 with 0.1 opacity

    // Water Gradient
    const waterGradient = ctx.createLinearGradient(0, 0, 0, 400);
    waterGradient.addColorStop(0, "rgba(66, 135, 245, 0.8)"); // #4287f5 with 0.8 opacity
    waterGradient.addColorStop(1, "rgba(66, 135, 245, 0.1)"); // #4287f5 with 0.1 opacity

    // BOE Gradient
    const boeGradient = ctx.createLinearGradient(0, 0, 0, 400);
    boeGradient.addColorStop(0, "rgba(214, 156, 6, 0.8)"); // #4287f5 with 0.8 opacity
    boeGradient.addColorStop(1, "rgba(214, 156, 6, 0.1)"); // #4287f5 with 0.1 opacity

    const chartLabels = Object.values(data).map((el) => el.date);
    const chartDataSets = [
      {
        label: "Oil Production",
        data: Object.values(data).map((el) => el.oil),
        borderColor: "#1ab65f",
        backgroundColor: oilGradient,
        borderWidth: 2,
        fill: false,
        pointStyle: "circle",
        pointRadius: 0,
        pointHoverRadius: 6,
        tension: 0.6,
      },
      {
        label: "Gas Production",
        data: Object.values(data).map((el) => el.gas / 6),
        borderColor: "#e22026",
        backgroundColor: gasGradient,
        borderWidth: 2,
        fill: false,
        pointStyle: "rectRot",
        pointRadius: 0,
        pointHoverRadius: 6,
        tension: 0.6,
      },
      {
        label: "Water Production",
        data: Object.values(data).map((el) => el.water),
        borderColor: "#4287f5",
        backgroundColor: waterGradient,
        borderWidth: 2,
        fill: false,
        hidden: true, // Starts hidden
        pointStyle: "triangle",
        pointRadius: 0, // Disable default point rendering
        pointHoverRadius: 6, // Enable hover effect
        tension: 0.6,
      },
      {
        label: "BOE",
        data: Object.values(data).map((el) => el.boe),
        borderColor: "#d69c06",
        backgroundColor: boeGradient,
        borderWidth: 2,
        fill: true,
        // hidden: true,
        pointStyle: "triangle",
        pointRadius: 0,
        pointHoverRadius: 6,
        tension: 0.6,
      },
    ];

    result.labels = [...chartLabels];
    result.datasets = [...chartDataSets];
    // console.log("processed ChartData", result);

    return result;
  }

  processChartDataProd(chartId) {
    const result = { labels: [], datasets: [] };

    const data = this.upstreamData[chartId];

    const container = this.querySelector('div[data-id="' + chartId + '"]');
    if (!container) return;

    const ctx = container.querySelector("canvas").getContext("2d");

    // Oil Gradient
    const oilGradient = ctx.createLinearGradient(0, 0, 0, 400);
    oilGradient.addColorStop(0, "rgba(26, 182, 95, 1)");
    oilGradient.addColorStop(1, "rgba(26, 182, 95, 0.6)");

    // Gas Gradient
    const gasGradient = ctx.createLinearGradient(0, 0, 0, 400);
    gasGradient.addColorStop(0, "rgba(226, 32, 38, 1)");
    gasGradient.addColorStop(1, "rgba(226, 32, 38, 0.6)");

    // Water Gradient
    const waterGradient = ctx.createLinearGradient(0, 0, 0, 400);
    waterGradient.addColorStop(0, "rgba(66, 135, 245, 1)");
    waterGradient.addColorStop(1, "rgba(66, 135, 245, 0.6)");

    const chartLabels = Object.values(data).map((el) => el.name);
    const chartDataSets = [
      {
        label: "Oil Production",
        data: Object.values(data).map((el) => el.data.oil),
        backgroundColor: oilGradient,
        stack: "Stack 0",
      },
      {
        label: "Gas Production",
        data: Object.values(data).map((el) => el.data.gas / 6),
        backgroundColor: gasGradient,
        stack: "Stack 0",
      },
      {
        label: "Water Production",
        data: Object.values(data).map((el) => el.data.water),
        backgroundColor: waterGradient,
        stack: "Stack 1",
        hidden: true,
      },
    ];

    result.labels = [...chartLabels];
    result.datasets = [...chartDataSets];
    // console.log("processed ChartData", result);

    return result;
  }

  processChartDataComp(chartId) {
    const result = { labels: [], datasets: [] };

    const data = this.upstreamData[chartId];

    const container = this.querySelector('div[data-id="' + chartId + '"]');
    if (!container) return;

    const ctx = container.querySelector("canvas").getContext("2d");

    const chartLabels = Object.values(data).map((el) => el.name);
    const chartDataSets = [
      {
        label: "Wells",
        data: Object.values(data).map((el) => el.count),
        backgroundColor: "#007bff", // Solid color for a single dataset
        pointRadius: 5,
      },
    ];

    result.labels = [...chartLabels];
    result.datasets = [...chartDataSets];
    // console.log("processed ChartData", result);

    return result;
  }
}

customElements.define("upstream-data", UpstreamData);
